<mat-progress-bar class="progress-margin" color="primary" *ngIf="loading" mode="indeterminate">
</mat-progress-bar>
<div class="card-container mat-elevation-z1">
    <form class="order-control" [formGroup]="form">
        <div class="card-content">
            <div>


                <mat-form-field  class="medium-width margin-right-small" *ngIf="showAppointmeDate">
                  <input  matInput formControlName="AppointmentDate" #dateOrder [matDatepicker]="pickerOrder" placeholder="Fecha del turno">
                  <mat-datepicker-toggle matSuffix [for]="pickerOrder"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOrder></mat-datepicker>
                  <mat-error *ngIf="f.AppointmentDate.errors && f.AppointmentDate.errors.required">
                    Ingrese la fecha
                </mat-error>
              </mat-form-field>


                <mat-form-field class="medium-width margin-right-small">
                    <input #equipment type="text" (input)="onEquipmentChange($event.target.value)" matInput placeholder="Equipo" required formControlName="Equipment" [matAutocomplete]="autEquipment">
                    <mat-autocomplete (optionSelected)="equipmentSelected($event.option.value)" #autEquipment="matAutocomplete" [displayWith]="filterCompleteEquipments.displayFn">
                        <mat-option *ngFor="let equipment of filteredEquipmentsOptions | async" [value]="equipment">
                            {{equipment.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="f.Equipment.errors && f.Equipment.errors.validAutoCompleteSelect">
                        Ingrese el equipo
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="medium-width margin-right-small">
                    <input type="text" (input)="onPhysicianChange($event.target.value)" matInput placeholder="Médico" required formControlName="Physician" [matAutocomplete]="autPhysician">
                    <mat-autocomplete (optionSelected)="physicianSelected($event.option.value)" #autPhysician="matAutocomplete" [displayWith]="filterCompleteEquipments.displayFn">
                        <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
                            {{physician.Name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="f.Physician.errors && f.Physician.errors.validAutoCompleteSelect">
                        Ingrese el médico
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="margin-right-small">
                    <mat-spinner *ngIf="loadingDuration" matSuffix [diameter]="20"></mat-spinner>
                    <input type="number" matInput placeholder="Duración" required formControlName="Duration">
                </mat-form-field>
            </div>
        </div>
        <div class="clearfix">
            <div class="pull-right margin-right-medium  margin-top-medium">
                <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
            </div>
            <div *ngIf="!loading" class="card-footer margin-top-medium">
                <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
                <button *ngIf="!loadingDuration" color="primary" mat-flat-button (click)="finalize()">SIGUIENTE</button>
            </div>
        </div>
    </form>
</div>
